export default {
    lang: {
        name: 'Comment'
    }
}